export const titleCase = (str) => {
    let reStr = str.replace(/_/g, " ")
    reStr = reStr.replace(
        /\w\S*/g,
        function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
    return reStr.trim();
}
